module.exports = __webpack_public_path__ + "img/orizontal_panou.39d5e527.png";